module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-cq9.04c9f39f.png";